import type { FC } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { Text } from '../../../ui-components';
import { GetIcon } from '../../icons';

export interface TurnToTagProps {
    tagText: string;
    id?: string;
    onRemove?: (tagText: string) => void;
}
export const TurnToTag: FC<TurnToTagProps> = ({ tagText, onRemove, id }) => (
    <Flex
        background="slt-pepper.1000"
        paddingX="1rem"
        borderRadius="11px"
        display="inline-flex"
        gap={2}
        alignItems="center"
    >
        <Text color="white" size="small" type="all-caps">
            {tagText}
        </Text>
        {onRemove && id ? (
            <Box onClick={() => onRemove?.(id)} cursor="pointer">
                <GetIcon name="close" size="sm" color="white" />
            </Box>
        ) : null}
    </Flex>
);
